// extracted by mini-css-extract-plugin
module.exports = {"Active":"NavItem_Active__2BhEt","Card":"NavItem_Card__3-wO-"};